(function() {
  'use strict';

  angular
    .module('admin.users.details.collections.sets', ['admin.users.details.collections.sets.prints'])
    .controller('CollectionsSetsAdminCtrl', CollectionsSetsAdminCtrl);

  /** @ngInject */
  function CollectionsSetsAdminCtrl($stateParams, CollectionsAdminService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.channelId = $stateParams.channelId;
    vm.username = $stateParams.username;
    vm.channels = [];

    load();

    function load(){
      CollectionsAdminService.listSetsForChannel($stateParams.parentId, vm.channelId).then(success);

      function success(result){
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }
        for (var i = 0; i < result.results.length; i++) {
          result.results[i].username = vm.username;
        }
        vm.items = result.results;
      }
    }
  }

})();
